<template>
    <div class="offer">
                <router-link :tag="'div'" :to="'/user/'+ user.id" class="offer-avatar" :style="{backgroundImage: 'url('+ getAvatar(user) +')'}">
                    <!-- <div class="people-rate" v-if="user.rate" :title="user.rate.title" :class="user.rate.color">
                        <img :src="require(`@/assets/images/defaults/icon_${user.rate.image}.png`)">
                    </div> -->
                </router-link>
                <div class="offer-wrap">
                    <router-link :tag="'p'" :to="'/user/'+ user.id" class="offer__name">{{ user.firstname + ' ' + user.lastname}}</router-link>
                    <div class="offer-buttons" v-if="$route.name == 'offers'">
                        <div class="button" @click.prevent.stop="acceptOffer()">
                            <img src="@/assets/images/icons/icon_check.svg" width="11px" v-if="accepted">
                            <p>{{accepted ? 'Принято' : 'Принять'}}</p>
                        </div>
                        <div class="offer-decline" @click.prevent.stop="declineOffer()" :class="{canceled: declined}">{{declined ? 'Отклонено' : 'Отклонить'}}</div>
                    </div>
                    <div class="offer-buttons"  v-else>
                        <div class="offer-decline" @click.prevent.stop="cancelOffer()" :class="{canceled: canceled}">{{canceled ? 'Заявка отменена' : 'Отменить заявку'}}</div>
                    </div>
                </div>
                
            </div>
</template>
<script>
export default {
    name: 'People',
    props: {
        user: {
            type: Object,
            required: true
        }
    },
    data: () => {
        return {
            canceled: false,
            declined: false,
            accepted: false
        }
    },
    methods: {
        getAvatar(user) {
            return user.deleted ? require('@/assets/images/defaults/dead.svg') : user.avatar
        },
        async declineOffer() {
            this.declined = await this.$store.dispatch('declineOffer', {from: this.user.id})
        },
        acceptOffer() {
            this.accepted = true
            this.$store.dispatch('acceptOffer', {from: this.user.id})
            let notifications = this.$store.getters.getUserNotifications;
            notifications.offers && notifications.offers > 0 
                ? (notifications.offers--, this.$store.dispatch('setNotifications', notifications))
                : ''
            this.$store.dispatch('createNotification', {from_id: this.$store.getters.getAuthUser.id, user: this.user.id, type: 'accept_friendship'} )
        },
        async cancelOffer() {
            this.canceled = await this.$store.dispatch('cancelOffer', {to: this.user.id})
        }
    }
}
</script>

<style lang="stylus">
.offer
    width 360px
    border-radius 20px
    background white
    box-shadow 0 0 15px #eaeaea
    padding 22px
    margin 7px
    display flex
    align-items center
    +to-width(900px)
        width calc(50% - 14px)
    +to-width(800px)
        width 360px
        margin 7px 0
    +to-width(420px)
        width 100%

    // .offer__name
    //     color white
    // .offer-avatar
    //     border 4px solid white


    &-avatar
        width 80px
        min-width 80px
        height 80px
        border-radius 50%
        background #333
        cursor pointer
        position relative
        z-index 2
        margin-right 20px
        background-size cover
        background-position top center
        background-image url('https://mir-s3-cdn-cf.behance.net/project_modules/disp/1bcdd944565991.5817acde24c51.gif')
        &:hover
            .people-elems
                transform rotate(100deg)
                opacity 1
                pointer-events all
    
    &__name
        font-size 15px
        font-weight 600
        color #191919
        position relative
        z-index 2
        cursor pointer
        
    &-wrap
        padding 5px 0
        display flex
        flex-direction column
        justify-content space-around

    &-buttons
        display flex
        align-items center
        margin-top 15px

        .button
            background-color #8fbc8f
            border-color #8fbc8f
            color white
            padding 8px 15px
            font-size 12px
            font-weight 600
            margin-right 15px
            display flex
            center()
            img
                margin-right 7px
            &:hover
                opacity 0.8
    
    &-decline
        color var(--text-main)
        font-size 12px
        opacity 0.4
        cursor pointer
        t()
        &.declined
            color crimson
            opacity 1
        &.canceled
            color crimson
            opacity 1

        &:hover
            opacity 1
    
    &-rate
        width 37px
        height 37px
        border-radius 50%
        background-color black
        position absolute
        left 5px
        top 5px
        center()
        border 2px solid white
        img
            max-width 60%
        
        &.green
            background-color $green
        
        &.indianred
            background-color indianred
    
    &_pseudo
        .offer__name
            width 160px
            height 20px
            border-radius 20px
            background-color #f0f0f0
        .button
            background-color #f0f0f0
            border-color #f0f0f0
            width 80px
        .offer-avatar
            background-image none
            background-color #f0f0f0
</style>